import React, { FunctionComponent, ReactNode } from 'react';
import { FullScreenWrapper } from 'components/Layouts/FullScreenView/FullScreenWrapper';

interface RecordingWrapperProps {
  children: ReactNode;
  artworkKey: string;
}

export const RecordingWrapper: FunctionComponent<RecordingWrapperProps> = ({
  children,
  artworkKey
}) => {
  return (
    <FullScreenWrapper
      artworkKey={artworkKey}
      artworkMode={'recording'}
      type={'recording'}
    >
      {children}
    </FullScreenWrapper>
  );
};
